/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetTextToSpeechHistoryRequest = {
  ttsId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const GetTextToSpeechHistoryRequest$inboundSchema: z.ZodType<
  GetTextToSpeechHistoryRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  tts_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "tts_id": "ttsId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type GetTextToSpeechHistoryRequest$Outbound = {
  tts_id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const GetTextToSpeechHistoryRequest$outboundSchema: z.ZodType<
  GetTextToSpeechHistoryRequest$Outbound,
  z.ZodTypeDef,
  GetTextToSpeechHistoryRequest
> = z.object({
  ttsId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    ttsId: "tts_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function getTextToSpeechHistoryRequestToJSON(
  getTextToSpeechHistoryRequest: GetTextToSpeechHistoryRequest,
): string {
  return JSON.stringify(
    GetTextToSpeechHistoryRequest$outboundSchema.parse(
      getTextToSpeechHistoryRequest,
    ),
  );
}
export function getTextToSpeechHistoryRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetTextToSpeechHistoryRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetTextToSpeechHistoryRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetTextToSpeechHistoryRequest' from JSON`,
  );
}
